import { Routes } from '@angular/router';
import { authGuard } from './routes/guards/auth.guard';
import { themeGuard } from './routes/guards/theme.guard';
import { unAuthGuard } from './routes/guards/un-auth.guard';
import { RouteSegments } from './types/route-segments';
import { orderOverviewGuard } from './routes/guards/order-overview.guard';
import { orderGuard } from './routes/guards/order.guard';

export const routes: Routes = [
	{
		path: RouteSegments.LOGIN,
		canMatch: [themeGuard, unAuthGuard],
		loadChildren: () => import('./routes/public.routes').then(m => m.publicRoutes),
	},
	{
		path: RouteSegments.ORDER,
		canMatch: [themeGuard, authGuard, orderGuard],
		loadChildren: () => import('./routes/private/order-routes').then(m => m.orderRoutes),
	},
	{
		path: RouteSegments.OVERVIEW,
		canMatch: [themeGuard, authGuard, orderOverviewGuard],
		loadChildren: () => import('./routes/private/order-overview-routes').then(m => m.orderOverviewRoutes),
	},
	{
		path: '**',
		redirectTo: RouteSegments.LOGIN,
		pathMatch: 'full',
	},
];
